import { render, staticRenderFns } from "./15_uploadFile.vue?vue&type=template&id=3b54c958&scoped=true&"
import script from "./15_uploadFile.vue?vue&type=script&lang=js&"
export * from "./15_uploadFile.vue?vue&type=script&lang=js&"
import style0 from "./15_uploadFile.vue?vue&type=style&index=0&id=3b54c958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b54c958",
  null
  
)

export default component.exports